import React from 'react';
import { Text } from '@input';
import { formatCurrency, isRefinance } from '@helpers';
import { keys } from '@enums';
import { isNumber } from 'lodash';

function LoanAmount(props) {
  return (
    <Text
      label="Loan Amount"
      className="input-loan-amount"
      fieldClassName="field-loan-amount"
      name={keys.LOAN_AMOUNT}
      maxWidth={140}
      hasError={props.hasError}
      isCurrency
      {...props}
    />
  );
}

function validate(num, state, validations) {
  num = parseFloat(num);

  if (isNaN(num)) {
    return 'Enter a valid loan amount';
  }

  let cashOutAmount = parseFloat(state.cashOutAmount);

  let { minLoanAmount = 0, maxLoanAmount = 0 } = validations;
  const hasMinLoanAmount = isNumber(minLoanAmount) && minLoanAmount > 0;
  const hasMaxLoanAmount =
    isNumber(maxLoanAmount) &&
    (hasMinLoanAmount ? maxLoanAmount > minLoanAmount : maxLoanAmount > 0);

  if (
    isRefinance(state.loanPurpose) &&
    !isNaN(cashOutAmount) &&
    cashOutAmount > 0
  ) {
    num += cashOutAmount;
  } else {
    cashOutAmount = 0;
  }

  if (hasMinLoanAmount || hasMaxLoanAmount) {
    if (hasMinLoanAmount && num < minLoanAmount) {
      return hasMaxLoanAmount
        ? `Enter a loan amount between ${formatCurrency(
          minLoanAmount
        )} and ${formatCurrency(maxLoanAmount - cashOutAmount)}`
        : `Enter a loan amount of at least ${formatCurrency(minLoanAmount)}`;
    } else if (hasMaxLoanAmount && num > maxLoanAmount) {
      return hasMinLoanAmount
        ? `Enter a loan amount between ${formatCurrency(
          minLoanAmount
        )} and ${formatCurrency(maxLoanAmount - cashOutAmount)}`
        : `Enter a loan amount of ${formatCurrency(
          maxLoanAmount - cashOutAmount
        )} or less`;
    }
  }

  if (!hasMinLoanAmount && num <= 0) {
    return 'Enter a loan amount of at least $0';
  }

  if (num >= parseFloat(state[keys.HOME_VALUE])) {
    const name =
      state.loanPurpose === 'purchase' ? 'purchase price' : 'home value';
    return `Loan amount must be less than ${name}`;
  }
}

export default {
  Component: LoanAmount,

  validate: {
    fn: validate,
    dependencies: [keys.HOME_VALUE, keys.CASH_OUT_AMOUNT]
  }
};
